// translations.js - Multi-language support for Bousla Landing Page

export const translations = {
    ar: {
        // Navigation
        nav: {
            home: "الرئيسية",
            services: "الخدمات",
            download: "التحميل"
        },

        // Hero Section
        hero: {
            title: "بوصلة",
            subtitle: "رحلتك تبدأ هنا",
            description: "تطبيق النقل الذكي الذي يوصلك لوجهتك بأمان وسرعة. خدمات متنوعة تلبي جميع احتياجاتك من نقل الركاب إلى توصيل الطلبات.",
            downloadBtn: "حمّل التطبيق الآن"
        },

        // Features
        features: {
            fast: {
                title: "سريع وآمن",
                desc: "وصول سريع مع أعلى معايير الأمان"
            },
            price: {
                title: "أسعار منافسة",
                desc: "أفضل الأسعار في السوق"
            },
            service: {
                title: "خدمة مميزة",
                desc: "دعم فني على مدار الساعة"
            },
            easy: {
                title: "سهل الاستخدام",
                desc: "واجهة بسيطة وسهلة للجميع"
            }
        },

        // Services Section
        services: {
            title: "خدماتنا",
            subtitle: "نوفر لك مجموعة متنوعة من خدمات النقل",
            passenger: {
                title: "نقل الركاب",
                desc: "خدمة نقل الركاب الفاخرة مع سائقين محترفين ومركبات حديثة ومريحة",
                features: [
                    "سيارات حديثة ونظيفة",
                    "سائقون مدربون",
                    "تتبع الرحلة مباشرة"
                ]
            },
            delivery: {
                title: "توصيل الطلبات",
                desc: "خدمة توصيل سريعة وآمنة لجميع طلباتك مع ضمان الجودة والسرعة",
                badge: "الأكثر طلباً",
                features: [
                    "توصيل سريع",
                    "تتبع الطلب لحظياً",
                    "ضمان سلامة الطلب"
                ]
            },
            school: {
                title: "نقل طلاب المدارس",
                desc: "خدمة نقل آمنة ومريحة لطلاب المدارس مع مراقبة كاملة للرحلات",
                features: [
                    "سائقون موثوقون",
                    "مراقبة الأهل للرحلة",
                    "مواعيد منتظمة"
                ]
            }
        },

        // Download Section
        download: {
            title: "حمّل التطبيق الآن",
            desc: "متوفر على جميع المنصات - ابدأ رحلتك مع بوصلة اليوم",
            appStore: "App Store",
            googlePlay: "Google Play",
            downloadFrom: "حمّل من"
        },

        // Footer
        footer: {
            tagline: "رحلتك تبدأ هنا",
            quickLinks: "روابط سريعة",
            contact: "تواصل معنا",
            rights: "© 2025 بوصلة - جميع الحقوق محفوظة",
            privacy: "سياسة الخصوصية"
        },

        // Privacy Policy
        privacy: {
            title: "سياسة الخصوصية",
            lastUpdated: "آخر تحديث: 18 مارس 2026",
            backHome: "العودة للرئيسية",
            sections: [
                {
                    title: "مقدمة",
                    content: "مرحباً بك في تطبيق بوصلة. نحن نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك عند استخدام تطبيقنا."
                },
                {
                    title: "المعلومات التي نجمعها",
                    content: "نقوم بجمع الأنواع التالية من المعلومات:",
                    list: [
                        "معلومات الحساب: الاسم، رقم الهاتف، البريد الإلكتروني عند التسجيل",
                        "بيانات الموقع الجغرافي: لتحديد موقعك وتوفير خدمات النقل والتوصيل",
                        "معلومات الجهاز: نوع الجهاز، نظام التشغيل، المعرّف الفريد للجهاز",
                        "سجل الرحلات: تفاصيل الرحلات والطلبات السابقة",
                        "معلومات الدفع: بيانات الدفع المشفرة لإتمام المعاملات"
                    ]
                },
                {
                    title: "كيف نستخدم معلوماتك",
                    content: "نستخدم المعلومات المجمعة للأغراض التالية:",
                    list: [
                        "تقديم خدمات النقل والتوصيل وتحسينها",
                        "معالجة المدفوعات والمعاملات المالية",
                        "التواصل معك بشأن الرحلات والتحديثات",
                        "تحسين تجربة المستخدم وتطوير التطبيق",
                        "ضمان أمان وسلامة المستخدمين",
                        "الامتثال للمتطلبات القانونية والتنظيمية"
                    ]
                },
                {
                    title: "مشاركة البيانات",
                    content: "نحن لا نبيع بياناتك الشخصية. قد نشارك معلوماتك في الحالات التالية:",
                    list: [
                        "مع السائقين: لإتمام الرحلات والتوصيل (الاسم، الموقع، رقم الهاتف)",
                        "مع مزودي الخدمات: شركات معالجة المدفوعات والخرائط",
                        "للمتطلبات القانونية: عند الطلب من الجهات المختصة وفقاً للقانون"
                    ]
                },
                {
                    title: "أمان البيانات",
                    content: "نطبق إجراءات أمان تقنية وتنظيمية لحماية بياناتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو الإتلاف. تشمل هذه الإجراءات التشفير، والتحكم في الوصول، والمراقبة المنتظمة لأنظمتنا."
                },
                {
                    title: "حقوقك",
                    content: "لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:",
                    list: [
                        "الوصول إلى بياناتك الشخصية وطلب نسخة منها",
                        "تصحيح أي بيانات غير دقيقة",
                        "حذف حسابك وبياناتك الشخصية",
                        "سحب موافقتك على معالجة البيانات في أي وقت",
                        "تقديم شكوى للجهة المختصة بحماية البيانات"
                    ]
                },
                {
                    title: "الاحتفاظ بالبيانات",
                    content: "نحتفظ ببياناتك الشخصية طالما أن حسابك نشط أو حسب الحاجة لتقديم الخدمات. يمكنك طلب حذف حسابك في أي وقت، وسنقوم بحذف بياناتك خلال 30 يوماً ما لم يكن هناك التزام قانوني بالاحتفاظ بها."
                },
                {
                    title: "خصوصية الأطفال",
                    content: "تطبيق بوصلة غير موجه للأطفال دون سن 13 عاماً. لا نجمع عن قصد بيانات شخصية من الأطفال. في حال اكتشفنا أننا جمعنا بيانات من طفل دون السن المحدد، سنقوم بحذفها فوراً."
                },
                {
                    title: "التغييرات على سياسة الخصوصية",
                    content: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإشعارك بأي تغييرات جوهرية عبر التطبيق أو البريد الإلكتروني. استمرارك في استخدام التطبيق بعد التغييرات يعني موافقتك عليها."
                },
                {
                    title: "تواصل معنا",
                    content: "إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارساتنا المتعلقة بالبيانات، يرجى التواصل معنا عبر:",
                    list: [
                        "البريد الإلكتروني: info@bousla.com",
                        "الهاتف: +963958855130"
                    ]
                }
            ]
        }
    },

    en: {
        // Navigation
        nav: {
            home: "Home",
            services: "Services",
            download: "Download"
        },

        // Hero Section
        hero: {
            title: "Bousla",
            subtitle: "Your Journey Starts Here",
            description: "The smart transportation app that gets you to your destination safely and quickly. Diverse services that meet all your needs from passenger transport to delivery.",
            downloadBtn: "Download App Now"
        },

        // Features
        features: {
            fast: {
                title: "Fast & Safe",
                desc: "Quick arrival with highest safety standards"
            },
            price: {
                title: "Competitive Prices",
                desc: "Best prices in the market"
            },
            service: {
                title: "Premium Service",
                desc: "24/7 technical support"
            },
            easy: {
                title: "Easy to Use",
                desc: "Simple and easy interface for everyone"
            }
        },

        // Services Section
        services: {
            title: "Our Services",
            subtitle: "We provide you with a variety of transportation services",
            passenger: {
                title: "Passenger Transport",
                desc: "Premium passenger transport service with professional drivers and modern, comfortable vehicles",
                features: [
                    "Modern and clean cars",
                    "Trained drivers",
                    "Live trip tracking"
                ]
            },
            delivery: {
                title: "Delivery Service",
                desc: "Fast and safe delivery service for all your orders with quality and speed guarantee",
                badge: "Most Popular",
                features: [
                    "Fast delivery",
                    "Real-time order tracking",
                    "Order safety guarantee"
                ]
            },
            school: {
                title: "School Transport",
                desc: "Safe and comfortable transport service for school students with complete trip monitoring",
                features: [
                    "Trusted drivers",
                    "Parent trip monitoring",
                    "Regular schedules"
                ]
            }
        },

        // Download Section
        download: {
            title: "Download the App Now",
            desc: "Available on all platforms - Start your journey with Bousla today",
            appStore: "App Store",
            googlePlay: "Google Play",
            downloadFrom: "Download from"
        },

        // Footer
        footer: {
            tagline: "Your Journey Starts Here",
            quickLinks: "Quick Links",
            contact: "Contact Us",
            rights: "© 2025 Bousla - All Rights Reserved",
            privacy: "Privacy Policy"
        },

        // Privacy Policy
        privacy: {
            title: "Privacy Policy",
            lastUpdated: "Last Updated: March 18, 2026",
            backHome: "Back to Home",
            sections: [
                {
                    title: "Introduction",
                    content: "Welcome to Bousla. We value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and protect your information when you use our application."
                },
                {
                    title: "Information We Collect",
                    content: "We collect the following types of information:",
                    list: [
                        "Account Information: Name, phone number, email address during registration",
                        "Location Data: To determine your location and provide transportation and delivery services",
                        "Device Information: Device type, operating system, unique device identifier",
                        "Trip History: Details of previous trips and orders",
                        "Payment Information: Encrypted payment data to complete transactions"
                    ]
                },
                {
                    title: "How We Use Your Information",
                    content: "We use the collected information for the following purposes:",
                    list: [
                        "Providing and improving transportation and delivery services",
                        "Processing payments and financial transactions",
                        "Communicating with you about trips and updates",
                        "Improving user experience and app development",
                        "Ensuring user safety and security",
                        "Complying with legal and regulatory requirements"
                    ]
                },
                {
                    title: "Data Sharing",
                    content: "We do not sell your personal data. We may share your information in the following cases:",
                    list: [
                        "With Drivers: To complete trips and deliveries (name, location, phone number)",
                        "With Service Providers: Payment processing and mapping companies",
                        "For Legal Requirements: When requested by authorities in accordance with the law"
                    ]
                },
                {
                    title: "Data Security",
                    content: "We implement technical and organizational security measures to protect your personal data from unauthorized access, modification, disclosure, or destruction. These measures include encryption, access controls, and regular monitoring of our systems."
                },
                {
                    title: "Your Rights",
                    content: "You have the following rights regarding your personal data:",
                    list: [
                        "Access your personal data and request a copy",
                        "Correct any inaccurate data",
                        "Delete your account and personal data",
                        "Withdraw your consent to data processing at any time",
                        "File a complaint with the relevant data protection authority"
                    ]
                },
                {
                    title: "Data Retention",
                    content: "We retain your personal data as long as your account is active or as needed to provide services. You can request account deletion at any time, and we will delete your data within 30 days unless there is a legal obligation to retain it."
                },
                {
                    title: "Children's Privacy",
                    content: "Bousla is not intended for children under 13 years of age. We do not knowingly collect personal data from children. If we discover that we have collected data from a child under the specified age, we will delete it immediately."
                },
                {
                    title: "Changes to Privacy Policy",
                    content: "We may update this Privacy Policy from time to time. We will notify you of any material changes through the app or email. Your continued use of the app after changes constitutes your acceptance of them."
                },
                {
                    title: "Contact Us",
                    content: "If you have any questions about this Privacy Policy or our data practices, please contact us at:",
                    list: [
                        "Email: info@bousla.com",
                        "Phone: +963958855130"
                    ]
                }
            ]
        }
    },

    fr: {
        // Navigation
        nav: {
            home: "Accueil",
            services: "Services",
            download: "Télécharger"
        },

        // Hero Section
        hero: {
            title: "Bousla",
            subtitle: "Votre Voyage Commence Ici",
            description: "L'application de transport intelligente qui vous emmène à destination en toute sécurité et rapidité. Des services variés qui répondent à tous vos besoins, du transport de passagers à la livraison.",
            downloadBtn: "Télécharger l'App"
        },

        // Features
        features: {
            fast: {
                title: "Rapide & Sûr",
                desc: "Arrivée rapide avec les normes de sécurité les plus élevées"
            },
            price: {
                title: "Prix Compétitifs",
                desc: "Les meilleurs prix du marché"
            },
            service: {
                title: "Service Premium",
                desc: "Support technique 24/7"
            },
            easy: {
                title: "Facile à Utiliser",
                desc: "Interface simple et facile pour tous"
            }
        },

        // Services Section
        services: {
            title: "Nos Services",
            subtitle: "Nous vous proposons une variété de services de transport",
            passenger: {
                title: "Transport de Passagers",
                desc: "Service de transport de passagers premium avec des chauffeurs professionnels et des véhicules modernes et confortables",
                features: [
                    "Voitures modernes et propres",
                    "Chauffeurs formés",
                    "Suivi en direct du trajet"
                ]
            },
            delivery: {
                title: "Service de Livraison",
                desc: "Service de livraison rapide et sûr pour toutes vos commandes avec garantie de qualité et de rapidité",
                badge: "Le Plus Populaire",
                features: [
                    "Livraison rapide",
                    "Suivi en temps réel",
                    "Garantie de sécurité"
                ]
            },
            school: {
                title: "Transport Scolaire",
                desc: "Service de transport sûr et confortable pour les élèves avec surveillance complète des trajets",
                features: [
                    "Chauffeurs de confiance",
                    "Surveillance parentale",
                    "Horaires réguliers"
                ]
            }
        },

        // Download Section
        download: {
            title: "Téléchargez l'App",
            desc: "Disponible sur toutes les plateformes - Commencez votre voyage avec Bousla aujourd'hui",
            appStore: "App Store",
            googlePlay: "Google Play",
            downloadFrom: "Télécharger depuis"
        },

        // Footer
        footer: {
            tagline: "Votre Voyage Commence Ici",
            quickLinks: "Liens Rapides",
            contact: "Contactez-nous",
            rights: "© 2025 Bousla - Tous Droits Réservés",
            privacy: "Politique de Confidentialité"
        },

        // Privacy Policy
        privacy: {
            title: "Politique de Confidentialité",
            lastUpdated: "Dernière mise à jour : 18 mars 2026",
            backHome: "Retour à l'accueil",
            sections: [
                {
                    title: "Introduction",
                    content: "Bienvenue sur Bousla. Nous valorisons votre vie privée et nous nous engageons à protéger vos données personnelles. Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre application."
                },
                {
                    title: "Informations que nous collectons",
                    content: "Nous collectons les types d'informations suivants :",
                    list: [
                        "Informations de compte : Nom, numéro de téléphone, adresse e-mail lors de l'inscription",
                        "Données de localisation : Pour déterminer votre position et fournir des services de transport et de livraison",
                        "Informations sur l'appareil : Type d'appareil, système d'exploitation, identifiant unique de l'appareil",
                        "Historique des trajets : Détails des trajets et commandes précédents",
                        "Informations de paiement : Données de paiement cryptées pour effectuer les transactions"
                    ]
                },
                {
                    title: "Comment nous utilisons vos informations",
                    content: "Nous utilisons les informations collectées aux fins suivantes :",
                    list: [
                        "Fournir et améliorer les services de transport et de livraison",
                        "Traiter les paiements et les transactions financières",
                        "Communiquer avec vous concernant les trajets et les mises à jour",
                        "Améliorer l'expérience utilisateur et le développement de l'application",
                        "Assurer la sécurité et la sûreté des utilisateurs",
                        "Se conformer aux exigences légales et réglementaires"
                    ]
                },
                {
                    title: "Partage des données",
                    content: "Nous ne vendons pas vos données personnelles. Nous pouvons partager vos informations dans les cas suivants :",
                    list: [
                        "Avec les chauffeurs : Pour effectuer les trajets et livraisons (nom, localisation, numéro de téléphone)",
                        "Avec les fournisseurs de services : Sociétés de traitement des paiements et de cartographie",
                        "Pour les exigences légales : Lorsque demandé par les autorités conformément à la loi"
                    ]
                },
                {
                    title: "Sécurité des données",
                    content: "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données personnelles contre l'accès non autorisé, la modification, la divulgation ou la destruction. Ces mesures comprennent le cryptage, les contrôles d'accès et la surveillance régulière de nos systèmes."
                },
                {
                    title: "Vos droits",
                    content: "Vous disposez des droits suivants concernant vos données personnelles :",
                    list: [
                        "Accéder à vos données personnelles et en demander une copie",
                        "Corriger toute donnée inexacte",
                        "Supprimer votre compte et vos données personnelles",
                        "Retirer votre consentement au traitement des données à tout moment",
                        "Déposer une plainte auprès de l'autorité compétente en matière de protection des données"
                    ]
                },
                {
                    title: "Conservation des données",
                    content: "Nous conservons vos données personnelles tant que votre compte est actif ou selon les besoins pour fournir les services. Vous pouvez demander la suppression de votre compte à tout moment, et nous supprimerons vos données dans les 30 jours, sauf obligation légale de les conserver."
                },
                {
                    title: "Confidentialité des enfants",
                    content: "Bousla n'est pas destiné aux enfants de moins de 13 ans. Nous ne collectons pas sciemment de données personnelles auprès d'enfants. Si nous découvrons que nous avons collecté des données d'un enfant en dessous de l'âge spécifié, nous les supprimerons immédiatement."
                },
                {
                    title: "Modifications de la politique de confidentialité",
                    content: "Nous pouvons mettre à jour cette Politique de Confidentialité de temps en temps. Nous vous informerons de tout changement important via l'application ou par e-mail. Votre utilisation continue de l'application après les modifications constitue votre acceptation de celles-ci."
                },
                {
                    title: "Contactez-nous",
                    content: "Si vous avez des questions concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter à :",
                    list: [
                        "E-mail : info@bousla.com",
                        "Téléphone : +963958855130"
                    ]
                }
            ]
        }
    }
};
